import React from 'react';
// import ReactDOM from 'react-dom';
import {render} from 'react-snapshot';
import websiteData from './data.json';

/* Import Routing */
import {BrowserRouter} from 'react-router-dom';

/* Import Translations */
import {createStore, combineReducers} from 'redux';
import {Provider} from 'react-redux';
import {localeReducer} from 'react-localize-redux';
import {setLanguages} from 'react-localize-redux';
import {addTranslation} from 'react-localize-redux';
import {reducer as reduxFormReducer} from 'redux-form';
import ScrollToTop from 'react-scroll-up';

/* Website components */
import Header from "./components/header/header";
import PageBody from "./pages/page_body";
import Footer from "./components/footer/footer";

const store = createStore(combineReducers({
    locale: localeReducer,
    form: reduxFormReducer
}));

const languages = websiteData.header.languages;

store.dispatch(setLanguages(languages));

const json = require('./global.locale.json');
store.dispatch(addTranslation(json));

const RootSite = () => (
    <span>
      <Header menuitems={websiteData.header.menuData} lang={websiteData.header.languages}
              logoContent={websiteData.header.headerLogo}/>
      <PageBody/>
      <Footer footerContent={websiteData.footer.footerContentTitles}
              footerCopyright={websiteData.footer.footerCopyright}
              footerPrivacyPolicy={websiteData.footer.footerPrivacyPolicy}/>
      <ScrollToTop showUnder={160} style={{zIndex: 10}}>
        <span className="gototop-arrow"><i className="icon-arrow-up"></i></span>
      </ScrollToTop>
    </span>
)

const App = props => {
    //console.log('render app')
    return (
        <Provider store={store}>
            <BrowserRouter>
                <RootSite/>
            </BrowserRouter>
        </Provider>
    );
};

// ReactDOM.render(
render(
    <App/>,
    document.getElementById('react-site')
); 





// WEBPACK FOOTER //
// ./src/index.js